import amplitude from 'amplitude-js'
import { getUserId, getPartnerId } from 'utils/authLocalStorage'
import {
  getWWUserId,
  getWWClientId,
  getWWAge,
  getWWBmi,
  getWWGender,
  getWWFeatures,
} from 'utils/wwLocalStorage'
import { useLoginUrl } from 'hooks/basicHooks'
import { postIframeMessage } from 'utils/basic'
import { getAmplitudeKey } from 'config'

const getAPIKey = (partnerId) => getAmplitudeKey(partnerId) || ''

export const amplitudeInit = (partnerId) => {
  const ampl = amplitude.getInstance('FITON')
  ampl.init(
    getAPIKey(partnerId),
    null,
    { includeReferrer: true, saveEvents: true },
    function () {}
  )
  ampl.setVersionName(process.env.REACT_APP_VERSION)
  window.ampl = ampl
  if (getUserId()) {
    logAmplitudeEvent('Session Start', {
      client_id: getWWClientId(),
      guid: getWWUserId(),
      age: getWWAge(),
      bmi: getWWBmi(),
      gender:
        getWWGender() === '1' || getWWGender() === 1
          ? 'Male'
          : getWWGender() === '2' || getWWGender() === 2
            ? 'Female'
            : 'Other',
      features: getWWFeatures(),
    })
  } else {
    const {
      clientId: client_id,
      guid,
      age,
      bmi,
      gender,
      features,
      // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useLoginUrl()
    if (client_id)
      logAmplitudeEvent('Session Start', {
        client_id: client_id,
        guid: guid,
        age: age,
        bmi: bmi,
        gender: gender === 1 ? 'Male' : 'Female',
        features,
      })
  }

  amplitudeLogin()
}

const setOption = (key, value) => {
  if (window.ampl) {
    const identify = new amplitude.Identify().set(key, value)
    window.ampl.identify(identify)
  }
}

export const amplitudeLogin = () => {
  if (getUserId()) {
    if (window.ampl) {
      window.ampl.setUserId(getUserId())
    }
    setOption('User Type', 'free')
    setOption('User State', 'returning')
  } else {
    setOption('User Type', 'free')
    setOption('User State', 'new')
  }
}

export const amplitudeUserDelete = () => {
  setOption('User State', 'deleted')
}

export const amplitudeDailyFix = (dailyFixNames) => {
  setOption('Daily Fix', dailyFixNames)
}

export const amplitudeMusicStation = (name) => {
  setOption('Music Station', name)
}

export const logAmplitudeEvent = (event, data) => {
  if (process.env.REACT_APP_ENV === 'staging') {
    console.log('%c' + event, 'background: red', data)
  }
  const isRevive = window.location.pathname?.includes('/revive')
  if (+getPartnerId() === 21 || isRevive) {
    postIframeMessage({ type: 'amplitudeEvent', data: { event, data } })
    if (window.ampl) {
      window.ampl.logEvent(event, data)
    }
  } else {
    if (window.ampl) {
      window.ampl.logEvent(event, data)
    }
  }
}

export const setAmplitudeProfile = (options) => {
  const {
    gender,
    age,
    completedWorkout,
    favoriteCategoryNames,
    clientId,
    features,
    guid,
    activityLevel,
    bmi,
  } = options
  if (gender || gender === 0)
    setOption(
      'Gender',
      gender === 1 || gender === '1'
        ? 'Male'
        : gender === 2 || gender === '2'
          ? 'Female'
          : 'Other'
    )
  if (age) setOption('Age', age)
  if (favoriteCategoryNames) setOption('Workout Types', favoriteCategoryNames)
  if (completedWorkout || completedWorkout === 0)
    setOption('Workouts', completedWorkout)
  setOption('User Type', 'free')
  if (clientId) setOption('Partner Client ID', clientId)
  if (guid) setOption('Partner GUID', guid)
  if (activityLevel) setOption('Activity Level', activityLevel)
  if (bmi) setOption('BMI', bmi)
  if (features) setOption('Features', features)
  // Clear the secret previously stored as a user property (WEB-595)
  if (clientId && window.ampl) {
    window.ampl.identify(
      new amplitude.Identify().unset('Partner Client Secret')
    )
  }
}
